import React, {useEffect} from "react";
import {isArrayEmpty} from "../../utils/gameUtils/hasNotEmpty";
import {createRandomDragItem} from "../../utils/gameUtils/getInitialDragData";
import {DragItemType, GridItemType} from "../../types";
import {useSizeItem} from "../../provider/ResizeProvider";

interface Props {
    gridData: GridItemType[][];
    setDragItems: React.Dispatch<React.SetStateAction<DragItemType[]>>;
}

export const useCheckEmptyGridData = ({gridData, setDragItems}: Props) => {
    const {panelItemSize} = useSizeItem();

    useEffect(() => {
        const isEmptyGridData = isArrayEmpty(gridData);
        if (isEmptyGridData) {
            setDragItems([
                createRandomDragItem(panelItemSize, 0),
                createRandomDragItem(panelItemSize, 1),
                createRandomDragItem(panelItemSize, 2),
            ])
        }
    }, [])
}